import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const subscriptionsPerformanceReportWidget: DashboardWidgetConfiguration = {
  widgetId: "subscriptions.performance-report",
  name: "Subscription performance",
  description: "Subscription performance using the reusable report-widget visualization.",
  apps: [
    "subscriptions",
  ],
  template: "report",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "subscriptions.records",
      ...period(30),
      select: [
        {
          type: "field",
          field: "billing_period",
          as: "billing_period",
        },
        {
          type: "aggregate",
          function: "sum",
          field: "recurring_amount",
          as: "revenue",
        },
      ],
      group_by: [
        {
          field: "billing_period",
        },
      ],
      order_by: [
        {
          ref: "revenue",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "Subscription performance",
    subtitle: "Live RQL report",
    output: "pie",
    visualization: "donut",
    icon: "average",
    showTimeControls: true,
  },
  dummyData: {
    value: "$48,260",
    series: [
      18,
      30,
      24,
      42,
      35,
    ],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
